import { render } from "./MoneyCheckEditor.vue?vue&type=template&id=29ba9c4c&ts=true"
import script from "./MoneyCheckEditor.vue?vue&type=script&lang=ts"
export * from "./MoneyCheckEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__